/**
 * WGS84 -> Schweizer Landeskoordinaten LV95.
 *
 * Die Näherungsformel von swisstopo ("Näherungsformeln für die Transformation
 * zwischen Schweizer Projektionskoordinaten und WGS84"), auf rund einen Meter
 * genau. Für eine Anzeige und die Höhenabfrage genügt das; auf Vermessung ist
 * diese Karte ohnehin nicht ausgelegt.
 */
export function nachLv95(lat, lng) {
  const phi = (lat * 3600 - 169028.66) / 10000;
  const lam = (lng * 3600 - 26782.5) / 10000;
  const ost = 2600072.37
    + 211455.93 * lam
    - 10938.51 * lam * phi
    - 0.36 * lam * phi * phi
    - 44.54 * lam * lam * lam;
  const nord = 1200147.07
    + 308807.95 * phi
    + 3745.25 * lam * lam
    + 76.63 * phi * phi
    - 194.56 * lam * lam * phi
    + 119.79 * phi * phi * phi;
  return { ost, nord };
}

/** Grob: liegt der Punkt im Gebiet, für das LV95 und swisstopos Höhen taugen? */
export function inDerSchweiz(lat, lng) {
  return lat > 45.75 && lat < 47.87 && lng > 5.88 && lng < 10.55;
}

/** 2'666'180 / 1'211'420 - so steht es auf der Landeskarte. */
export function lv95Text(lat, lng) {
  const { ost, nord } = nachLv95(lat, lng);
  const tausender = (x) => String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return `${tausender(ost)} / ${tausender(nord)}`;
}
